import { gql } from '@apollo/client';

export interface OptVersionsByReportIdResponse {
  allReportSummaries: {
    nodes: Array<{ version: string }>;
  };
}

//AIPD-885 query to get versions for a given opt report
export default gql`
  query OptVersionsByReportId($reportId: UUID!) {
    allReportSummaries(
      filter: {
        reportId: { equalTo: $reportId }
        version: { isNull: false }
      }
    ) {
      nodes {
        version
      }
    }
  }
`;